import type { FC } from 'react'

import { TRIPLE_DOT_LOADER } from '@liveHelper/testIds'

import { TripleDotLoaderContainer, TripleDots } from './TripleDotLoader.styles'

/**
 * TripleDotLoader Component
 *
 * A loading spinner component with three dots that animates to indicate ongoing activity.
 */
export const TripleDotLoader: FC = () => {
  return (
    <TripleDotLoaderContainer data-testid={TRIPLE_DOT_LOADER}>
      <TripleDots />
    </TripleDotLoaderContainer>
  )
}
